// BJCP 2021 Beer Style Guidelines - complete list
// Format: { code, name, category }
export const BJCP_STYLES = [
  // 1. Standard American Beer
  { code: "1A", name: "American Light Lager", category: "Standard American Beer" },
  { code: "1B", name: "American Lager", category: "Standard American Beer" },
  { code: "1C", name: "Cream Ale", category: "Standard American Beer" },
  { code: "1D", name: "American Wheat Beer", category: "Standard American Beer" },
  // 2. International Lager
  { code: "2A", name: "International Pale Lager", category: "International Lager" },
  { code: "2B", name: "International Amber Lager", category: "International Lager" },
  { code: "2C", name: "International Dark Lager", category: "International Lager" },
  // 3. Czech Lager
  { code: "3A", name: "Czech Pale Lager", category: "Czech Lager" },
  { code: "3B", name: "Czech Premium Pale Lager", category: "Czech Lager" },
  { code: "3C", name: "Czech Amber Lager", category: "Czech Lager" },
  { code: "3D", name: "Czech Dark Lager", category: "Czech Lager" },
  // 4. Pale Malty European Lager
  { code: "4A", name: "Munich Helles", category: "Pale Malty European Lager" },
  { code: "4B", name: "Festbier", category: "Pale Malty European Lager" },
  { code: "4C", name: "Helles Bock", category: "Pale Malty European Lager" },
  // 5. Pale Bitter European Lager
  { code: "5A", name: "German Leichtbier", category: "Pale Bitter European Lager" },
  { code: "5B", name: "Kölsch", category: "Pale Bitter European Lager" },
  { code: "5C", name: "German Helles Exportbier", category: "Pale Bitter European Lager" },
  { code: "5D", name: "German Pils", category: "Pale Bitter European Lager" },
  // 6. Amber Malty European Lager
  { code: "6A", name: "Märzen", category: "Amber Malty European Lager" },
  { code: "6B", name: "Rauchbier", category: "Amber Malty European Lager" },
  { code: "6C", name: "Dunkles Bock", category: "Amber Malty European Lager" },
  // 7. Amber Bitter European Lager
  { code: "7A", name: "Vienna Lager", category: "Amber Bitter European Lager" },
  { code: "7B", name: "Altbier", category: "Amber Bitter European Lager" },
  { code: "7C", name: "Kellerbier", category: "Amber Bitter European Lager" },
  // 8. Dark European Lager
  { code: "8A", name: "Munich Dunkel", category: "Dark European Lager" },
  { code: "8B", name: "Schwarzbier", category: "Dark European Lager" },
  // 9. Strong European Beer
  { code: "9A", name: "Doppelbock", category: "Strong European Beer" },
  { code: "9B", name: "Eisbock", category: "Strong European Beer" },
  { code: "9C", name: "Baltic Porter", category: "Strong European Beer" },
  // 10. German Wheat Beer
  { code: "10A", name: "Weissbier", category: "German Wheat Beer" },
  { code: "10B", name: "Dunkles Weissbier", category: "German Wheat Beer" },
  { code: "10C", name: "Weizenbock", category: "German Wheat Beer" },
  // 11. British Bitter
  { code: "11A", name: "Ordinary Bitter", category: "British Bitter" },
  { code: "11B", name: "Best Bitter", category: "British Bitter" },
  { code: "11C", name: "Strong Bitter", category: "British Bitter" },
  // 12. Pale Commonwealth Beer
  { code: "12A", name: "British Golden Ale", category: "Pale Commonwealth Beer" },
  { code: "12B", name: "Australian Sparkling Ale", category: "Pale Commonwealth Beer" },
  { code: "12C", name: "English IPA", category: "Pale Commonwealth Beer" },
  // 13. Brown British Beer
  { code: "13A", name: "Dark Mild", category: "Brown British Beer" },
  { code: "13B", name: "British Brown Ale", category: "Brown British Beer" },
  { code: "13C", name: "English Porter", category: "Brown British Beer" },
  // 14. Scottish Ale
  { code: "14A", name: "Scottish Light", category: "Scottish Ale" },
  { code: "14B", name: "Scottish Heavy", category: "Scottish Ale" },
  { code: "14C", name: "Scottish Export", category: "Scottish Ale" },
  // 15. Irish Beer
  { code: "15A", name: "Irish Red Ale", category: "Irish Beer" },
  { code: "15B", name: "Irish Stout", category: "Irish Beer" },
  { code: "15C", name: "Irish Extra Stout", category: "Irish Beer" },
  // 16. Dark British Beer
  { code: "16A", name: "Sweet Stout", category: "Dark British Beer" },
  { code: "16B", name: "Oatmeal Stout", category: "Dark British Beer" },
  { code: "16C", name: "Tropical Stout", category: "Dark British Beer" },
  { code: "16D", name: "Foreign Extra Stout", category: "Dark British Beer" },
  // 17. Strong British Ale
  { code: "17A", name: "British Strong Ale", category: "Strong British Ale" },
  { code: "17B", name: "Old Ale", category: "Strong British Ale" },
  { code: "17C", name: "Wee Heavy", category: "Strong British Ale" },
  { code: "17D", name: "English Barleywine", category: "Strong British Ale" },
  // 18. Pale American Ale
  { code: "18A", name: "Blonde Ale", category: "Pale American Ale" },
  { code: "18B", name: "American Pale Ale", category: "Pale American Ale" },
  // 19. Amber and Brown American Beer
  { code: "19A", name: "American Amber Ale", category: "Amber and Brown American Beer" },
  { code: "19B", name: "California Common", category: "Amber and Brown American Beer" },
  { code: "19C", name: "American Brown Ale", category: "Amber and Brown American Beer" },
  // 20. American Porter and Stout
  { code: "20A", name: "American Porter", category: "American Porter and Stout" },
  { code: "20B", name: "American Stout", category: "American Porter and Stout" },
  { code: "20C", name: "Imperial Stout", category: "American Porter and Stout" },
  // 21. IPA
  { code: "21A", name: "American IPA", category: "IPA" },
  { code: "21B", name: "Specialty IPA (Belgian, Black, Brown, Red, Rye, White)", category: "IPA" },
  { code: "21C", name: "Hazy IPA", category: "IPA" },
  // 22. Strong American Ale
  { code: "22A", name: "Double IPA", category: "Strong American Ale" },
  { code: "22B", name: "American Strong Ale", category: "Strong American Ale" },
  { code: "22C", name: "American Barleywine", category: "Strong American Ale" },
  { code: "22D", name: "Wheatwine", category: "Strong American Ale" },
  // 23. European Sour Ale
  { code: "23A", name: "Berliner Weisse", category: "European Sour Ale" },
  { code: "23B", name: "Flanders Red Ale", category: "European Sour Ale" },
  { code: "23C", name: "Oud Bruin", category: "European Sour Ale" },
  { code: "23D", name: "Lambic", category: "European Sour Ale" },
  { code: "23E", name: "Gueuze", category: "European Sour Ale" },
  { code: "23F", name: "Fruit Lambic", category: "European Sour Ale" },
  { code: "23G", name: "Gose", category: "European Sour Ale" },
  // 24. Belgian Ale
  { code: "24A", name: "Witbier", category: "Belgian Ale" },
  { code: "24B", name: "Belgian Pale Ale", category: "Belgian Ale" },
  { code: "24C", name: "Bière de Garde", category: "Belgian Ale" },
  // 25. Strong Belgian Ale
  { code: "25A", name: "Belgian Blond Ale", category: "Strong Belgian Ale" },
  { code: "25B", name: "Saison", category: "Strong Belgian Ale" },
  { code: "25C", name: "Belgian Golden Strong Ale", category: "Strong Belgian Ale" },
  // 26. Monastic Ale
  { code: "26A", name: "Trappist Single", category: "Monastic Ale" },
  { code: "26B", name: "Belgian Dubbel", category: "Monastic Ale" },
  { code: "26C", name: "Belgian Tripel", category: "Monastic Ale" },
  { code: "26D", name: "Belgian Dark Strong Ale", category: "Monastic Ale" },
  // 27. Historical Beer
  { code: "27", name: "Historical Beer (Kellerbier, Steinbier, Pre-Prohibition Lager, etc.)", category: "Historical Beer" },
  // 28. American Wild Ale
  { code: "28A", name: "Brett Beer", category: "American Wild Ale" },
  { code: "28B", name: "Mixed-Fermentation Sour Beer", category: "American Wild Ale" },
  { code: "28C", name: "Wild Specialty Beer", category: "American Wild Ale" },
  { code: "28D", name: "Straight Sour Beer", category: "American Wild Ale" },
  // 29. Fruit Beer
  { code: "29A", name: "Fruit Beer", category: "Fruit Beer" },
  { code: "29B", name: "Fruit and Spice Beer", category: "Fruit Beer" },
  { code: "29C", name: "Specialty Fruit Beer", category: "Fruit Beer" },
  { code: "29D", name: "Grape Ale", category: "Fruit Beer" },
  // 30. Spiced Beer
  { code: "30A", name: "Spice, Herb, or Vegetable Beer", category: "Spiced Beer" },
  { code: "30B", name: "Autumn Seasonal Beer", category: "Spiced Beer" },
  { code: "30C", name: "Winter Seasonal Beer", category: "Spiced Beer" },
  { code: "30D", name: "Specialty Spice Beer", category: "Spiced Beer" },
  // 31. Alternative Fermentables Beer
  { code: "31A", name: "Alternative Grain Beer", category: "Alternative Fermentables Beer" },
  { code: "31B", name: "Alternative Sugar Beer", category: "Alternative Fermentables Beer" },
  // 32. Smoked Beer
  { code: "32A", name: "Classic Style Smoked Beer", category: "Smoked Beer" },
  { code: "32B", name: "Specialty Smoked Beer", category: "Smoked Beer" },
  // 33. Wood Beer
  { code: "33A", name: "Wood-Aged Beer", category: "Wood Beer" },
  { code: "33B", name: "Specialty Wood-Aged Beer", category: "Wood Beer" },
  // 34. Specialty Beer
  { code: "34A", name: "Commercial Specialty Beer", category: "Specialty Beer" },
  { code: "34B", name: "Mixed-Style Beer", category: "Specialty Beer" },
  { code: "34C", name: "Experimental Beer", category: "Specialty Beer" },
  // X. Special Categories
  { code: "X1", name: "Dorada Pampeana", category: "Special Categories" },
  { code: "X2", name: "IPA Argenta", category: "Special Categories" },
  { code: "X3", name: "Italian Grape Ale", category: "Special Categories" },
];
